import { IMapState } from '../types';

export function selectViewedCianIds(state: IMapState): Record<number, true> {
  return state.map.viewedCianIds;
}
